
/**
 * model
 * @param  {Any} ...args
 * @return {Function}
 */
function model(...args) {
	return function(target, name, descriptor) {

	}
};

export {
	model
};
